import { render, staticRenderFns } from "./PastSurvey.vue?vue&type=template&id=679d24a6&scoped=true&"
import script from "./PastSurvey.vue?vue&type=script&lang=js&"
export * from "./PastSurvey.vue?vue&type=script&lang=js&"
import style0 from "./PastSurvey.vue?vue&type=style&index=0&id=679d24a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679d24a6",
  null
  
)

export default component.exports